import type { RouteRecordRaw } from 'vue-router'

// The insight dashboard lives as the first tab of the Dashboard page
// (AlertDashboard.vue), gated by the ENABLE_NEW_DASHBOARD feature toggle.
// `/home` is kept only so links from the POC era still land somewhere sensible,
// and it redirects rather than rendering the dashboard itself: gating has to
// come from one place, and a page-level check here would be a second one. It
// would also have to be an async check — `useFeatureFlag` reports `false` both
// while the check is in flight and when the toggle is off, so a guard here would
// either flash the dashboard before redirecting or hang if the check failed.
// Redirecting inherits the tab's gating instead: toggle on lands on Overview,
// toggle off lands on the first alert tab. `admin.dashboard`'s own meta governs
// roles and platforms, since the router guard reads the resolved target.
export const home: RouteRecordRaw = {
  name: 'admin.home',
  path: 'home',
  redirect: { name: 'admin.dashboard' },
}
